import type { NumberToChineseLabels } from ".";

const labels: NumberToChineseLabels = {
  digits: ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
  units: [
    "",
    "十",
    "百",
    "千",
    "萬",
    "十",
    "百",
    "千",
    "億",
    "十",
    "百",
    "千",
    "兆",
    "十",
    "百",
    "千",
    "京",
    "十",
    "百",
    "千",
    "垓",
  ],
  ordinal: "第",
  point: "點",
  minus: "負",
};

export default labels;
